<template>
  <div class="plans">
    <va-card id="card-principal" :title="$t(`postsAddUpdate.title.${title}`)">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(upload)">
          <div class="row">
            <div class="flex md12" id="erro">
            </div>
            <div class="flex md12">
              <ValidationProvider rules="required" name="Titulo" v-slot="{ errors }">
                <va-input v-model="post.title" :label="$t('postsAddUpdate.forms.titleLabel')"
                  :placeholder="$t('postsAddUpdate.forms.titlePlaceholder')"
                  :success="errors.length == 0 && post.title.length > 0" :error="errors.length > 0"
                  :error-messages="errors" />
              </ValidationProvider>
              <label>{{$t('postsAddUpdate.forms.collumnLabel')}}</label>
              <va-toggle class="mb-3" v-model="post.collumn" small :label="post.collumn ? 'Sim' : 'Não'" />
              <label>{{$t('postsAddUpdate.forms.exclusiveLabel')}}</label>
              <va-toggle class="mb-3" v-model="post.exclusive" small :label="post.exclusive ? 'Sim' : 'Não'" />
              <div class="form-group" v-for="(clubM, idc) in club" :key="idc">
                <div class="row">
                  <div :class="idc == 0 ? ['flex', 'md12'] : ['flex', 'md10']">
                    <va-select :label="$t('postsAddUpdate.forms.clubsLabel')" v-model="club[idc]" textBy="name"
                      keyBy='id' no-clear :placeholder="$t('postsAddUpdate.forms.clubsPlaceholder')"
                      :noOptionsText="$t('postsAddUpdate.forms.clubsNoOption')" maxHeight='200px' searchable
                      :options="clubs.length > 0 ? clubs : []" />
                  </div>
                  <div v-if="idc != 0" class="flex md2">
                    <va-button type="button" color="danger" @click="removeClub(idc)">
                      Remover Clube
                    </va-button>
                  </div>
                </div>
              </div>
              <div class="form-group mt-0 mb-3">
                <va-button type="button" @click="addClub">
                  Adicionar Outro Clube
                </va-button>
              </div>
              <ValidationProvider rules="required" name="Conteudo da Postagem" v-slot="{ errors }">
                <ckeditor :editor="editor" id='editor' v-model="post.body" :config="editorConfig"></ckeditor>
                <ErrorMessages :errors='errors' />
              </ValidationProvider>
              <div v-if='oldImage.length > 0' class="form-group mt-3">
                <img :src="oldImage.includes('http') ? oldImage : $store.getters['environment/cdn'] + '/posts/' + oldImage"
                  style="height: 30vh; max-width: 100%;">
              </div>
              <ValidationProvider name="Capa" :rules="oldImage.length > 0 ? '' : 'required'" v-slot="{ errors }">
                <div class="form-group mt-3">
                  <label class="va-input__container__label position" style="color: rgb(108, 127, 238);">
                    {{$t('postsAddUpdate.forms.capaLabel')}}
                  </label>
                  <va-file-upload type="single" v-model="image"/>
                  <ErrorMessages :errors='errors' />
                </div>
                <va-modal
                  v-model="modalCrop"
                  :title="$t('modals.titleCrop')"
                  message=""
                  :noEscDismiss="true"
                  :noOutsideDismiss="true"
                  class="modal"
                  :hideDefaultActions="true"
                >
                  <template slot="default">
                    <cropper v-if="image64"
                      class="cropper"
                      ref="cropper"
                      :src="image64"
                      :stencil-props="{
                        aspectRatio: 16/9,
                        autoZoom: true,
                      }"
                      :defaultSize="defaultSize"
                    />
                  </template>
                  <template slot="actions">
                    <va-button @click="crop">{{$t('modals.confirm')}}</va-button>
                  </template>
                </va-modal>
              </ValidationProvider>
              <va-input v-model="post.image_credits" :label="$t('postsAddUpdate.forms.creditsLabel')"
                :placeholder="$t('postsAddUpdate.forms.creditsPlaceholder')" />
              <div class="d-flex mt-3">
                <va-button type="submit" :disabled="loading" color="success" class="my-0">
                  {{ textSubmit }}
                </va-button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
      <div
        id="spinner"
        class="spinner-hidden"
      >
        <OrbitSpinner
          :animation-duration="1500"
          :color="'#e34b4a'"
          :size="100"
        />
      </div>
    </va-card>
  </div>
</template>

<script>
import ErrorMessages from '../utils/ErrorMessages'
import Editor from 'ckeditor5-custom-build/build/ckeditor.js'
import './ckeditor.css'
import gql from 'graphql-tag'
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'
import { OrbitSpinner } from 'epic-spinners'
export default {
  name: 'postsAdd',
  components: { ErrorMessages, Cropper, OrbitSpinner },
  props: {
    title: {
      type: String,
      default: 'add',
    },
    postId: {
      type: Number,
      default: null,
    },
  },
  created () {
    if (this.postId !== null) {
      this.$apollo.addSmartQuery('post', {
        query: gql`query MyQuery($id: Int!) {
          post: post_by_pk(id: $id) {
            body
            image
            subtitle
            title
            collumn
            exclusive
            image_credits
            postClubs: post_clubs {
              club {
                id
                name
              }
            }
            date
          }
        }
        `,
        variables: {
          id: this.postId,
        },
        manual: true,
        result ({ data, loading }) {
          if (!loading) {
            const {
              body,
              image,
              subtitle,
              title,
              postClubs,
              collumn,
              exclusive,
            } = data.post
            const imageCredits = data.post.image_credits
            this.post = Object.assign({}, {
              body,
              image,
              subtitle,
              title,
              collumn,
              exclusive,
              image_credits: imageCredits,
            })
            this.oldImage = image
            this.post.image = ''
            const clubs = []
            postClubs.forEach(element => {
              // console.log(element.club)
              clubs.push(Object.assign({}, element.club))
            })
            this.club = clubs
          }
        },
      })
    }
  },
  mounted () {
    if (Object.keys(this.$apollo.queries).includes('post')) {
      this.$apollo.queries.post.refetch()
      // this.$apollo.queries.clubs.refetch()
    }
  },
  methods: {
    erro (err) {
      document.getElementById('erro').innerHTML = '<div class="va-notification" style="background: rgba(248, 112, 109, 0.2); box-shadow: rgba(248, 112, 109, 0.6) 0px 0.125rem 0.125rem 0px;">' +
      '  <div class="va-notification__content">' +
      '      <div class="va-badge mr-2" style="color: rgb(255, 255, 255); border-color: rgb(248, 112, 109); background-color: rgb(248, 112, 109);">' +
      '        <div class="va-badge__content d-flex">' +
      '            <div class="va-badge__content__title flex-center">Erro</div>' +
      '        </div>' +
      '      </div>' +
            err +
      '  </div>' +
      '  <div class="va-notification__close-icon"><i class="va-icon ion-md-close ion" style="color: rgb(248, 112, 109);"></i></div>' +
      '</div>'
    },
    closeSpinner () {
      var opacity = document.getElementById('card-principal')
      opacity.classList.remove('opacity-submit')
      var spinner = document.getElementById('spinner')
      spinner.classList.remove('spinner')
      spinner.classList.add('spinner-hidden')
    },
    openSpinner () {
      var opacity = document.getElementById('card-principal')
      opacity.classList.add('opacity-submit')
      var spinner = document.getElementById('spinner')
      spinner.classList.add('spinner')
      spinner.classList.remove('spinner-hidden')
    },
    defaultSize ({ imageSize }) {
      return {
        width: imageSize.width,
        height: imageSize.height,
      }
    },
    getBase64 (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = reject
      })
    },
    closeModalCrop () {
      this.modalCrop = false
    },
    toggleShow () {
      this.show = !this.show
    },
    urltoFile (url, filename, mimeType) {
      if (url.startsWith('data:')) {
        var arr = url.split(',')
        var mime = arr[0].match(/:(.*?);/)[1]
        var bstr = atob(arr[arr.length - 1])
        var n = bstr.length
        var u8arr = new Uint8Array(n)
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }
        var file = new File([u8arr], filename, { type: mime || mimeType })
        return Promise.resolve(file)
      }
      return fetch(url)
        .then(res => res.arrayBuffer())
        .then(buf => new File([buf], filename, { type: mimeType }))
    },
    async crop () {
      this.modalCrop = false
      this.image64 = null
      const imageLocal = this.image[this.image.length - 1]
      const { canvas } = this.$refs.cropper.getResult()
      this.post.image = imageLocal.name
      this.image.push(await this.urltoFile(canvas.toDataURL(), imageLocal.name, imageLocal.type))
    },
    slugfy (str) {
      return str.toLowerCase()
        .replace(/[àÀáÁâÂãäÄÅåª]+/g, 'a') // Special Characters #1
        .replace(/[èÈéÉêÊëË]+/g, 'e') // Special Characters #2
        .replace(/[ìÌíÍîÎïÏ]+/g, 'i') // Special Characters #3
        .replace(/[òÒóÓôÔõÕöÖº]+/g, 'o') // Special Characters #4
        .replace(/[ùÙúÚûÛüÜ]+/g, 'u') // Special Characters #5
        .replace(/[ýÝÿŸ]+/g, 'y') // Special Characters #6
        .replace(/[ñÑ]+/g, 'n') // Special Characters #7
        .replace(/[çÇ]+/g, 'c') // Special Characters #8
        .replace(/[ß]+/g, 'ss') // Special Characters #9
        .replace(/[Ææ]+/g, 'ae') // Special Characters #10
        .replace(/[Øøœ]+/g, 'oe') // Special Characters #11
        .replace(/[%]+/g, 'pct') // Special Characters #12
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(/[^\w-]+/g, '') // Remove all non-word chars
        .replace(/--+/g, '-') // Replace multiple - with single -
        .replace(/^-+/, '') // Trim - from start of text
        .replace(/-+$/, '') // Trim - from end of text
    },
    addClub () {
      this.club.push(Object.assign({}, this.clubs[0]))
    },
    removeClub (ind) {
      this.club.splice(ind, ind)
    },
    upload () {
      this.openSpinner()
      if (this.post.image.length !== 0) {
        const formData = new FormData()
        formData.append('file', this.image[this.image.length - 1])
        if (this.postId !== null) {
          formData.append('deleteFile', this.oldImage)
        }
        this.$axios.post(
          '/api/upload',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          },
        ).then(resp => {
          this.post.image = resp.data.filename
          this.onSubmit()
        }).catch(err => {
          this.closeSpinner()
          this.erro(err + ' ' + err.response.status)
        })
      } else {
        this.post.image = this.oldImage
        this.onSubmit()
      }
    },
    onSubmit () {
      this.loading = true
      this.textSubmit = this.$t('forms.submitting')
      const div = document.createElement('div')
      div.innerHTML = this.post.body
      this.post.subtitle = div.textContent.substring(0, 120) + '...'
      if (this.postId !== null) {
        this.post.club_id.forEach(element => {
          element.post_id = this.postId
        })
      }
      this.post.slug = this.slugfy(this.post.title)
      if (this.post.club_id.length > 0) {
        this.post.club = this.post.club_id[0].club_id
      } else {
        this.post.club = null
      }
      this.$apollo
        .mutate({
          mutation: this.postId === null ? gql`
            mutation MyMutation(
                $title: String!,
                $subtitle: String!,
                $image: String! ,
                $body: String!,
                $collumn : Boolean!,
                $slug : String!,
                $exclusive : Boolean!,
                $image_credits : String!,
                $club_id: [post_club_insert_input!]!,
                $club: Int!
              ) {
              insert_post(objects: {
                  title: $title,
                  subtitle: $subtitle,
                  image: $image,
                  body: $body,
                  collumn: $collumn,
                  slug: $slug,
                  exclusive: $exclusive,
                  image_credits: $image_credits,
                  club_id: $club,
                  post_clubs: {data: $club_id}
                }) {
                affected_rows
              }
            }
          ` : gql`
            mutation MyMutation(
              $title: String!,
              $subtitle: String!,
              $image: String!,
              $body: String!,
              $id: Int!,
              $collumn : Boolean!,
              $slug: String!,
              $exclusive : Boolean!,
              $image_credits : String!,
              $club_id: [post_club_insert_input!]!,
              $club: Int!
            ) {
              delete_post_club(where: {post_id: {_eq: $id}}) {
                affected_rows
              }
              insert_post_club(objects: $club_id) {
                affected_rows
              }
              update_post_by_pk(
                pk_columns: {id: $id},
                _set: {
                  body: $body,
                  image: $image,
                  title: $title,
                  subtitle: $subtitle,
                  collumn: $collumn,
                  slug: $slug,
                  exclusive: $exclusive,
                  image_credits: $image_credits,
                  club_id: $club
                }
              ) {
                id
              }
            }
          `,
          variables: this.postId === null ? this.post : {
            ...this.post,
            id: this.postId,
          },
        })
        .then(data => {
          this.loading = false
          this.textSubmit = this.$t('forms.submit')
          this.showToast(
            this.$t(this.postId === null ? 'toasts.successCreate' : 'toasts.successUpdate'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
              onComplete: () => this.$router.push({ name: 'posts' }),
            },
          )
        })
        .catch(err => {
          this.closeSpinner()
          this.erro(err)
          this.loading = false
          this.textSubmit = this.$t('forms.submit')
          this.showToast(
            this.$t(this.postId === null ? 'toasts.errorCreate' : 'toasts.errorUpdate'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
  watch: {
    image (value) {
      if (value.length > 0 && value.length % 2 !== 0) {
        const ind = value.length - 1
        this.post.image = value[ind].name
        this.image64 = null
        this.getBase64(value[ind]).then((f) => {
          this.modalCrop = true
          this.image64 = f
        })
      }
    },
    club (value) {
      if (value !== '') {
        const ids = []
        value.forEach(element => {
          ids.push({ club_id: element.id })
        })
        this.post.club_id = ids
      }
    },
  },
  data () {
    return {
      modalCrop: false,
      image64: null,
      show: false,
      post: {
        title: '',
        subtitle: '',
        body: '',
        club_id: [''],
        image: '',
        image_credits: '',
        collumn: false,
        exclusive: false,
      },
      image: [],
      club: [''],
      clubs: [],
      oldImage: '',
      loading: false,
      textSubmit: this.$t('forms.submit'),
      editor: Editor,
      editorConfig: {
        toolbar: {
          items: [
            'heading',
            '|',
            'bold',
            'italic',
            'link',
            'bulletedList',
            'numberedList',
            '|',
            'outdent',
            'indent',
            '|',
            'imageUpload',
            'blockQuote',
            'htmlEmbed',
            'insertTable',
            'mediaEmbed',
            'undo',
            'redo',
          ],
        },
        language: 'pt-br',
        image: {
          toolbar: [
            'imageTextAlternative',
            'toggleImageCaption',
            'imageStyle:inline',
            'imageStyle:block',
            'imageStyle:side',
          ],
        },
        table: {
          contentToolbar: [
            'tableColumn',
            'tableRow',
            'mergeTableCells',
          ],
        },
        htmlEmbed: {
          showPreviews: true,
        },
        mediaEmbed: {
          previewsInData: true,
          providers: [
            {
              name: 'youtube',
              url: [
                /^(?:m\.)?youtube\.com\/watch\?v=([\w-]+)/,
                /^(?:m\.)?youtube\.com\/v\/([\w-]+)/,
                /^youtube\.com\/embed\/([\w-]+)/,
                /^youtu\.be\/([\w-]+)/,
              ],
              html: match => {
                const id = match[1]
                return (
                  '<div class="embed-responsive embed-responsive-16by9">' +
                    '<iframe ' +
                      'class="frame" ' +
                      `src="https://www.youtube.com/embed/${id}?rel=0&amp;autoplay=0&mute=1'" ` +
                      'frameborder="0" ' +
                      'allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" ' +
                      'allowfullscreen>' +
                    '</iframe>' +
                  '</div>'
                )
              },
            },
          ],
          removeProviders: [
            'instagram',
            'twitter',
            'googleMaps',
            'flickr',
            'facebook',
            'spotify',
            'vimeo',
            'dailymotion',
          ],
        },
      },
    }
  },
  apollo: {
    clubs: {
      query: gql`
      query MyQuery {
        clubs: club(where: {id: {_neq: 1}}, order_by: {id: asc}) {
          id
          name
          logo
        }
      }
      `,
      result ({ data, loading }) {
        if (!loading) {
          if (data.clubs.length > 0 && this.club.length === 0) {
            this.club = [Object.assign({}, data.clubs[0])]
          }
        }
      },
    },
  },
}
</script>

<style scoped>
.cropper {
  border: solid 1px #eeeeee;
  max-height: 80%;
  max-width: 100%;
  width: 100%;
}

.position {
  position: relative;
}

.opacity-submit {
  opacity: 0.6;
}

.spinner {
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

.spinner-hidden {
  display: none;
}
</style>

<style>
  .va-modal__inner {
    height: 100%;
  }

  .modal .title {
    font-size: 1rem;
  }

  .vue-advanced-cropper__stretcher {
    height: 25rem !important;
  }

  .vue-advanced-cropper__background {
    background: #ffffff;
  }

  @media only screen and (max-width: 768px) {
    .vue-advanced-cropper__stretcher {
      width: 20rem !important;
    }

    .va-modal__inner {
      padding-top: 20% !important;
    }
  }
</style>
